import type {SVGProps} from 'react'
import * as React from 'react'
const DeleteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2324 5.89913C11.5448 5.58671 11.5448 5.08018 11.2324 4.76776C10.92 4.45534 10.4135 4.45534 10.101 4.76776L8.00006 6.86874L5.89908 4.76776C5.58666 4.45534 5.08013 4.45534 4.76771 4.76776C4.45529 5.08018 4.45529 5.58671 4.76771 5.89913L6.86869 8.00011L4.76771 10.1011C4.45529 10.4135 4.45529 10.92 4.76771 11.2325C5.08013 11.5449 5.58666 11.5449 5.89908 11.2325L8.00006 9.13148L10.101 11.2325C10.4135 11.5449 10.92 11.5449 11.2324 11.2325C11.5448 10.92 11.5448 10.4135 11.2324 10.1011L9.13143 8.00011L11.2324 5.89913Z"
      fill="white"
    />
  </svg>
)
export default DeleteIcon
